import { composeFetch } from '@library/http'
import {
  addPath,
  composeRequest,
  goustoHeaders,
  setMethod,
  setQueryParams,
  setServiceUrl,
} from '@library/http/requests'

import type { MenuURN, RecipeURN } from './interfaces/identifiers'
import type { RecipeUUID } from './interfaces/recipe'

type RecipeIdentifier =
  | { recipeId: RecipeUUID; recipeUrn?: never }
  | { recipeId?: never; recipeUrn: RecipeURN }

type MenuIdentifier = { menuId: string; menuUrn?: never } | { menuId?: never; menuUrn: MenuURN }

export type FlexQueryInput = RecipeIdentifier &
  MenuIdentifier & {
    numPortions: number
    deliveryDate?: string
  }

export type FlexPortion = {
  label: string
  numPortions: number
  descriptionHTML: string
  isAvailable?: boolean
  promotionMessageHTML?: string
}

export type FlexResponse = {
  portions: FlexPortion[]
}

const getFlexResponseParser = async (response: Response): Promise<FlexResponse> => {
  if (!response.ok) {
    const responseMsg = await response.text()
    throw new Error(`service responded with ${response.status}: ${responseMsg}`)
  }

  return response.json() as Promise<FlexResponse>
}

export const flexFetcher = composeFetch(
  composeRequest<FlexQueryInput>(
    setServiceUrl('menuexperience', 1),
    addPath(({ recipeId, recipeUrn }) => `menu/recipe/${recipeUrn ?? recipeId}/flex`),
    goustoHeaders,
    setMethod('GET'),
    setQueryParams(({ menuId, menuUrn, numPortions, deliveryDate }) => ({
      ...(menuUrn !== undefined ? { menuUrn } : { menuId }),
      numPortions: numPortions.toString(),
      ...(deliveryDate && { deliveryDate }),
    })),
  ),
  getFlexResponseParser,
)
